module.exports = __webpack_public_path__ + "static/media/noblesse.6f6f7e10.webp";